import script from "./Answers.vue?vue&type=script&setup=true&lang=ts"
export * from "./Answers.vue?vue&type=script&setup=true&lang=ts"

import "./Answers.vue?vue&type=style&index=0&id=009bdc62&lang=scss"

const __exports__ = script;

export default __exports__